import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Tabs} from '@/components/ui/tab-atoms/TabAtoms'
import styled, {css} from 'styled-components'

export const StyledPatientDetailsTabs = styled(Tabs)`
    display: grid;
    grid-template-columns: 1fr auto;
    width: 100%;
    height: 100%;
`

export const StyledPrintCoverButton = styled(ButtonLink)(
    ({theme: {palette}}) => css`
        color: ${palette.primary['500']};
        align-self: center;
        &:hover {
            color: ${palette.primary['500']};
        }
    `
)

export const StyledGenerationHelpText = styled(Flexbox)`
    flex-shrink: 0;
`
